import { render, staticRenderFns } from "./ReportingMajorHighlight.vue?vue&type=template&id=15847d8e&scoped=true&"
import script from "./ReportingMajorHighlight.vue?vue&type=script&lang=js&"
export * from "./ReportingMajorHighlight.vue?vue&type=script&lang=js&"
import style0 from "./ReportingMajorHighlight.vue?vue&type=style&index=0&id=15847d8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15847d8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow,VSpacer})
